export const MEMBER_DELETE = "MEMBER_DELETE";
export const TYPE_ADD_MEMBER = 'TYPE_ADD_MEMBER';
export const GET_MEMBER_LIST = 'GET_MEMBER_LIST';
export const GET_MEMBER_DETAILS="GET_MEMBER_DETAILS";
export const UPDATE_MEMBER_DETAILS="UPDATE_MEMBER_DETAILS";
export const GET_CALL_UASGE_LIST="GET_CALL_UASGE_LIST";
export const GET_ROLE_ACCESS_LIST="GET_ROLE_ACCESS_LIST";
export const GET_SAVE_AND_EDIT_DATA="GET_SAVE_AND_EDIT_DATA";
export const GET_SIDEMENU_DETAILS = 'GET_SIDEMENU_DETAILS';
